<template>
  <div>
    <div class="w3-row">
      <div class="w3-col w3-quarter">
        <content-header v-bind:title="showOverview ? $t('consultations') : ((physicians && physicians[0]) ? physicians[0].name : '')"></content-header>
      </div>

      <div class="w3-col w3-quarter w3-right flow-content-actions-header flow-margin-bottom"
           v-if="!isNormal">
        <div class="flow-padding-top w3-large w3-right flow-form-action active w3-margin-right">
          <button class="flow-btn w3-btn w3-border w3-ripple w3-round-medium cursor-pointer w3-ripple flow-blue-color w3-large"
                  @click.prevent="viewIndex ^= 1"
                  v-if="viewIndex === 0 && physicians && physicians.length > 0">
                            <span>
                                <i class="fa fa-stethoscope flow-green-active-color">
                                </i>
                                <b class="flow-margin-left">
                                    {{ $t('goToMyConsultations') }}
                                </b>
                            </span>
            <i class="fa fa-chevron-right"></i>
          </button>

          <button class="flow-btn w3-btn w3-border w3-ripple w3-round-medium cursor-pointer w3-ripple flow-blue-color w3-large"
                  @click.prevent="viewIndex ^= 1"
                  v-if="viewIndex === 1">
                            <span>
                                <i class="fa fa-calendar-alt flow-green-active-color">
                                </i>
                                <b class="flow-margin-left">
                                    {{ $t('goToConsultationsOverview') }}
                                </b>
                            </span>
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <ConsultationInMinimalRoom v-if="showConsultation && hasMinimalStructure"
                               :room="room"
                               :propsPhysician="physicians[0]">
    </ConsultationInMinimalRoom>

    <consultation-in-room v-if="showConsultation && !hasMinimalStructure"
                          :propsPhysician="physicians[0]"
                          class="w3-animate-opacity"></consultation-in-room>

    <ConsultationsOverview v-if="showOverview" class="w3-animate-opacity"></ConsultationsOverview>
  </div>
</template>

<script>
import Vue from 'vue';
import ConsultationInRoom from "../components/consultation/ConsultationInRoom";
import ConsultationsOverview from "../components/consultation/ConsultationsOverview";
import ContentHeader from "../components/common/ContentHeader";
import ConsultationInMinimalRoom from "../components/consultation/ConsultationInMinimalRoom";

const frc = Vue.prototype.$frc;

    export default {
        name: "Consultation",
        components: {ConsultationInRoom, ConsultationsOverview, ContentHeader, ConsultationInMinimalRoom},
        data() {
            return {
                physicians: [],
                viewIndex: undefined,
                room: undefined,
                hasMinimalStructure: false,
                wardId: undefined
            }

        },
        beforeMount() {
            const cu = Vue.prototype.$currentUser;
            this.wardId = Vue.prototype.$currentWard.id;
            var uPhysicians = cu.user.physicians;
            if (!this.isNormal) {
              this.viewIndex = 0;
            }

            if (uPhysicians) {
                const app = this;
                for (let index in uPhysicians) {
                  Vue.prototype.$frc.getPhysicianWithId(uPhysicians[index]).then(function (res) {
                    let phy = res.data;
                    if (phy.ward.id !== app.wardId) {
                      return;
                    }
                    app.physicians.push(res.data);
                    var rooms = res.data.rooms;
                    if (rooms && rooms.length > 0) {
                      app.getRoom(rooms[0].id);
                    }
                  });
                }
            }
        },
      watch: {
          physicians(o, n) {
            const cu = Vue.prototype.$currentUser;
            if (!Vue.isNormal(cu.user.role)) {
              return;
            }
            let noOfPhysicians = n.length;
            if (noOfPhysicians === 0) {
              Vue.notifyError({title: this.$t("NO_PHYSICIAN_LINKED")});
            } else if (noOfPhysicians === 1) {
              this.viewIndex = 1;
            } else {
              this.viewIndex = 0;
            }
          }
      },
      computed: {
            isNormal() {
                return Vue.isNormal(Vue.prototype.$currentUser.user.role);
            },
            showConsultation() {
                return this.viewIndex === 1 && this.physicians.length === 1;
            },
            showOverview() {
                return this.viewIndex === 0 && (this.physicians.length > 1 || !this.isNormal);
            }
        },
        methods: {
            getRoom(roomId) {
                var app = this;
                app.room = undefined;
                frc.getConsultationRoomInWard(app.wardId, roomId).then(function (res) {
                    app.room = res.data;
                    var uiSettings = app.room !== undefined ? app.room.group.uiSettings.entry : [];
                    app.hasMinimalStructure = Vue.getValueForKey(uiSettings, 'minimalRoomStructure');
                });
            },
        }
    }
</script>

<style scoped>

</style>